import { updateClient } from "../graphql/mutations";
import { getStripeAmount } from "../modules/AdhocBookingService";
import { postApi, graphql, graphqlOperation } from "../modules/AmplifyServices";

/**
 * Charges the customer and processes the payment
 * @param {Object} client - Client information
 * @param {Object} company - Company information
 * @param {Object} cbu - Booking information
 * @param {string} currency - Currency code
 */
export const chargeAndProcessPayment = async ({
    client,
    company,
    cbu,
    currency
}) => {
    try {
        const resultStripeCharge = await postApi(
            "stripechargecard",
            "/stripechargecard",
            {
                body: {
                    receiptemailaddress: client.user.emailaddress,
                    stripecustomerid: client.stripeCustomerId,
                    customerCurrency: currency,
                    amount: cbu.total ? getStripeAmount(cbu.total) : 0,
                    credit: false,
                    prevcharge: false,
                    companyId: company.id,
                    stripeAccount: company.stripeAccount,
                    stripeConnectEnabled: company.stripeConnectEnabled
                }
            }
        );

        if (resultStripeCharge?.error) {
            return { error: resultStripeCharge.error.raw?.message };
        }

        if (!resultStripeCharge?.charge?.paid) {
            return { error: "Unable to process payment" };
        }

        return resultStripeCharge;
    } catch (error) {
        console.error("Error while processing payment:", error);
        return { error: "Unable to process your payment: " + error.message };
    }
};
